import styles from "./styles.json";
const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

let $pm = $(".pipeline-map");
let $termsDialog = $("#accept-terms");
let $infoBox = $("#info-box");

function setCookie(key, value, options = {}) {
  if (value === null || value === undefined) {
    options.expires = -1;
  }
  if (typeof options.expires === "number") {
    let days = options.expires;
    let t = options.expires = new Date();
    t.setDate(t.getDate() + days);
  }
  value = String(value);
  document.cookie = [
    encodeURIComponent(key), "=",
    options.raw ? value : encodeURIComponent(value),
    options.expires ? "; expires=" + options.expires.toUTCString() : "",
    options.path ? "; path=" + options.path : "",
    options.domain ? "; domain=" + options.domain : "",
    options.secure ? "; secure" : ""
  ].join("");
}

function getCookie(key, options = {}) {
  let decode = options.raw ? function decode(s) { return s; } : decodeURIComponent;
  let result = new RegExp("(?:^|; )" + encodeURIComponent(key) + "=([^;]*)").exec(document.cookie);
  return result ? decode(result[1]) : null;
}

if ($termsDialog) {
  $termsDialog.addEventListener("close", function termsSubmit(e) {
    e.preventDefault();
    setCookie("termsOfUseAck", "true", { expires: 7 });
    $termsDialog.close();
  });
}

if ($pm) {
  let apiKey = "AIzaSyC91rPhRogIhz27NleuQXkAMRFLR8n01Yk";

  $pm.innerHTML = "";

  function doMap() {
    let script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&loading=async&callback=initMap";
    script.async = true;
    document.head.appendChild(script); 
  }

  window.initMap = function() {
    let geocoder = new google.maps.Geocoder();

    let mapOptions = {
      center: new google.maps.LatLng(38.24761295957137, -97.163617187499985),
      zoom: (window.innerWidth >= 1024 ? 5 : 3),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: styles,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      fullscreenControl: true
    };

    let map = new google.maps.Map($pm, mapOptions);

    let kmlOptions = {
      preserveViewport: true,
      suppressInfoWindows: true
    };

    let kmzURL = window.location.protocol + "//" + window.location.host + "/content/includes/MPL_Pipeline.kmz";

    let layer = new google.maps.KmlLayer(kmzURL + "?v=" + Date.now(), kmlOptions);

    let image = {
      url: "/images/marathonpipeline/marker.png",
      size: new google.maps.Size(33, 45),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 45)
    };

    let shadow = {
      url: "/images/marathonpipeline/shadow.png",
      size: new google.maps.Size(59, 45),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 45)
    };

    let shape = {
      coord: [18, 2, 21, 3, 22, 4, 24, 5, 25, 6, 26, 7, 26, 8, 27, 9, 27, 10, 28, 11, 28, 12, 28, 13, 28, 14, 28, 15, 28, 16, 28, 17, 28, 18, 28, 19, 28, 20, 27, 21, 27, 22, 26, 23, 26, 24, 25, 25, 25, 26, 24, 27, 24, 28, 23, 29, 23, 30, 22, 31, 21, 32, 21, 33, 20, 34, 19, 35, 19, 36, 18, 37, 17, 38, 16, 39, 16, 40, 15, 41, 14, 41, 13, 40, 13, 39, 12, 38, 11, 37, 10, 36, 10, 35, 9, 34, 8, 33, 8, 32, 7, 31, 6, 30, 6, 29, 5, 28, 5, 27, 4, 26, 4, 25, 3, 24, 3, 23, 2, 22, 2, 21, 1, 20, 1, 19, 1, 18, 1, 17, 1, 16, 1, 15, 1, 14, 1, 13, 1, 12, 1, 11, 2, 10, 2, 9, 3, 8, 3, 7, 4, 6, 5, 5, 7, 4, 8, 3, 11, 2, 18, 2],
      type: "poly"
    };

    google.maps.event.addListener(layer, "status_changed", function mapStatusChanged() {
      let status = layer.getStatus();
      if (status !== google.maps.KmlLayerStatus.OK) {
        console.log("Failed to load KML Layer with status:", status);
      }
    });

    layer.setMap(map);

    google.maps.event.addListener(layer, "click", function layerClick(layerEvent) {
      let description = layerEvent.featureData.description.trim();
      let dataSrc, $rows, $segInfo, system, keys;

      if (description.indexOf("</table>") > -1) {
        dataSrc = [];
        let parser = new DOMParser();
        let doc = parser.parseFromString(description, 'text/html');
        $rows = doc.querySelectorAll("table table tr");
        $rows.forEach(row => {
          let $columns = row.querySelectorAll("td");
          let key = $columns[0].innerText.trim();
          let value = $columns[1].innerText.trim();
          dataSrc.push(key + "  " + value);
        });
      } else {
        dataSrc = layerEvent.featureData.description.split(/\s+<br>(?:\s+<br>\s+)?\s+/);
      }

      $segInfo = $infoBox.querySelector("#segment-info");
      system = {};

      map.panTo(layerEvent.latLng);

      if ($pm.clientWidth > 600) {
        map.panBy(160, 0);
      }

      $infoBox.querySelector(".close").addEventListener("click", function infoBoxClick() {
        $infoBox.close();
      });

      keys = ["SYSTEM_NAM", "Product", "Diameter", "PSI"];
      dataSrc.forEach(text => {
        let kv = text.split(/\s\s+/);
        let key = kv[0];
        let value = kv[1];

        if (keys.indexOf(key) === -1) {
          return;
        }

        if (key === "SYSTEM_NAM") {
          system.systemName = value;
        } else {
          system[key] = value;
        }
      });

      $infoBox.show();
      $segInfo.innerHTML = "<div class=\"infoBoxField\"><div class=\"label\">Pipeline Name</div><div class=\"value\">" + system.systemName + "</div></div>";

      Object.keys(system).forEach(key => {
        let displayKey = key;
        if (key !== "systemName" && key !== "System_Nam" && key !== "SYSTEM_NAM" && key !== "FID" && key !== "States") {
          if (key === "Product") {
            displayKey = "Products Transported";
          }
          if (key === "Size of Line" || key === "Diameter") {
            displayKey = "Pipeline Diameter";
          }
          if (key === "PSI") {
            displayKey = "Typical Operating Pressure (psi)";
          }
          $segInfo.innerHTML += "<div class=\"infoBoxField\"><div class=\"label\">" + displayKey + "</div><div class=\"value\">" + system[key] + "</div></div>";
        }
      });
    });

    function codeAddress(event) {
      event.preventDefault();
      let address = this.querySelector("input#address").value;
      let marker;
      geocoder.geocode({ "address": address }, function geocodeDone(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          map.panTo(results[0].geometry.location);
          map.fitBounds(results[0].geometry.viewport);
          $infoBox.close();
          marker = new google.maps.Marker({
            icon: image,
            shadow: shadow,
            shape: shape,
            map: map,
            position: results[0].geometry.location
          });
        } else {
          console && console.log("Geocode was not successful for the following reason: " + status);
        }
      });
    }

    $("#map-search").addEventListener("submit", codeAddress);
  }

  doMap();

  if (getCookie("termsOfUseAck")) {
    $termsDialog.close();
  }
}
